import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      fetchingBundle: "Fetching bundle details...",
      bundleNotFound: "Bundle Not Found",
      bundleNotFoundDesc: "We couldn't retrieve the details for this bundle. Please check the URL or try again.",
      plantPortal: "Plant Portal",
      bundleDetails: "Bundle Details",
      bundleWarnings: "Bundle Warnings",
      untitledBundle: "Untitled Bundle",
      totalQty: "Total Qty",
      itemsCount: "{{qty}} items",
      totalWeight: "Total Weight",
      maxLength: "Max Length",
      loadSeq: "Load Seq",
      stackingInfo: "Stacking Info",
      stackLevel: "{{level}} Level",
      loadingPriority: "Priority: {{priority}}",
      handlingInstruction: "Handling Instruction",
      noHandlingInstructions: "No special handling instructions.",
      notes: "Notes",
      bundleItems: "Bundle Items ({{count}})",
      partCode: "Part Code",
      description: "Description",
      qty: "Qty",
      lengthFt: "Length (Ft)",
      weightLbs: "Weight (Lbs)",
      length: "Length",
      weight: "Weight",
      markIds: "Mark IDs",
      marks: "Marks:",
      lbs: "lbs",
      ft: "ft",

      // Packing List Plan Details keys
      fetchingPackingListPlan: "Fetching packing list plan...",
      packingListPlanNotFound: "Packing List Plan Not Found",
      packingListPlanNotFoundDesc: "We couldn't retrieve the details for this packing list plan. Please check the URL or try again.",
      packingListPlan: "Packing List Plan",
      totalBundles: "Total Bundles",
      bundlesCount: "{{qty}} bundles",
      packingLists: "Packing Lists",
      listsCount: "{{count}} lists",
      truckSummaryBreakdown: "Truck Summary Breakdown",
      totalTrucks: "Total Trucks: {{count}}",
      semi53Flatbed: "Semi 53' Flatbed",
      hotshot40: "Hotshot 40'",
      packingListsWithCount: "Packing Lists ({{count}})",
      packingListNo: "Packing List No",
      truckType: "Truck Type",
      bundlesBreakdownWithCount: "Bundles Breakdown ({{count}})",
      seq: "Seq",
      type: "Type",
      status: "Status",
      pending: "Pending",
      assignedToTruck: "Assigned to Truck",
      semi53Count: "Semi 53'",
      hotshot40Count: "Hotshot 40'",

      // Packing List Details keys
      fetchingPackingList: "Fetching packing list...",
      packingListNotFound: "Packing List Not Found",
      packingListNotFoundDesc: "We couldn't retrieve the details for this packing list. Please check the URL or try again.",
      packingListDetails: "Packing List Details",
      truckInfo: "Truck & Capacity",
      truckNo: "Truck No",
      truckDetails: "Truck Details",
      maxCapacity: "Max Capacity",
      weightUtilization: "Weight Utilization",
      lengthLimit: "Length Limit",
      loadLayout: "Load Layout & Layers",
      loadingNotes: "Loading Notes",
      topLayer: "Top Layer",
      middleLayer: "Middle Layer",
      bottomLayer: "Bottom Layer",
      viewPlan: "View Plan",
      viewBundle: "View Bundle",
      itemsInBundle: "{{count}} items in this bundle",
      confirmed: "Confirmed",
      warnings: "Warnings",
    },
  },
  es: {
    translation: {
      fetchingBundle: "Obteniendo detalles del paquete...",
      bundleNotFound: "Paquete No Encontrado",
      bundleNotFoundDesc: "No pudimos recuperar los detalles de este paquete. Por favor, verifique la URL o intente nuevamente.",
      plantPortal: "Portal de Planta",
      bundleDetails: "Detalles del Paquete",
      bundleWarnings: "Advertencias del Paquete",
      untitledBundle: "Paquete sin Título",
      totalQty: "Cant. Total",
      itemsCount: "{{qty}} artículos",
      totalWeight: "Peso Total",
      maxLength: "Longitud Máxima",
      loadSeq: "Sec. de Carga",
      stackingInfo: "Información de Apilamiento",
      stackLevel: "Nivel {{level}}",
      loadingPriority: "Prioridad: {{priority}}",
      handlingInstruction: "Instrucción de Manipulación",
      noHandlingInstructions: "Sin instrucciones especiales de manipulación.",
      notes: "Notas",
      bundleItems: "Artículos del Paquete ({{count}})",
      partCode: "Código de Parte",
      description: "Descripción",
      qty: "Cant",
      lengthFt: "Longitud (Ft)",
      weightLbs: "Peso (Lbs)",
      length: "Longitud",
      weight: "Peso",
      markIds: "IDs de Marca",
      marks: "Marcas:",
      lbs: "lbs",
      ft: "ft",

      // Packing List Plan Details keys
      fetchingPackingListPlan: "Obteniendo plan de lista de empaque...",
      packingListPlanNotFound: "Plan de Lista de Empaque no Encontrado",
      packingListPlanNotFoundDesc: "No pudimos recuperar los detalles de este plan de lista de empaque. Por favor, verifique la URL o intente nuevamente.",
      packingListPlan: "Plan de Lista de Empaque",
      totalBundles: "Paquetes Totales",
      bundlesCount: "{{qty}} paquetes",
      packingLists: "Listas de Empaque",
      listsCount: "{{count}} listas",
      truckSummaryBreakdown: "Desglose de Resumen de Camiones",
      totalTrucks: "Camiones Totales: {{count}}",
      semi53Flatbed: "Plataforma Semi 53'",
      hotshot40: "Hotshot 40'",
      packingListsWithCount: "Listas de Empaque ({{count}})",
      packingListNo: "N.º de Lista de Empaque",
      truckType: "Tipo de Camión",
      bundlesBreakdownWithCount: "Desglose de Paquetes ({{count}})",
      seq: "Sec",
      type: "Tipo",
      status: "Estado",
      pending: "Pendiente",
      assignedToTruck: "Asignado a Camión",
      semi53Count: "Semi 53'",
      hotshot40Count: "Hotshot 40'",

      // Packing List Details keys
      fetchingPackingList: "Obteniendo lista de empaque...",
      packingListNotFound: "Lista de Empaque no Encontrada",
      packingListNotFoundDesc: "No pudimos recuperar los detalles de esta lista de empaque. Por favor, verifique la URL o intente nuevamente.",
      packingListDetails: "Detalles de la Lista de Empaque",
      truckInfo: "Camión y Capacidad",
      truckNo: "N.º de Camión",
      truckDetails: "Detalles del Camión",
      maxCapacity: "Capacidad Máx.",
      weightUtilization: "Utilización de Peso",
      lengthLimit: "Límite de Longitud",
      loadLayout: "Diseño y Capas de Carga",
      loadingNotes: "Notas de Carga",
      topLayer: "Capa Superior",
      middleLayer: "Capa Media",
      bottomLayer: "Capa Inferior",
      viewPlan: "Ver Plan",
      viewBundle: "Ver Paquete",
      itemsInBundle: "{{count}} artículos en este paquete",
      confirmed: "Confirmado",
      warnings: "Advertencias",
    },
  },
};

const savedLanguage = localStorage.getItem("i18nextLng") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
});

export default i18n;
